import { FilePdfIcon, PrinterIcon } from '@phosphor-icons/react';
import { Button } from '@skupreme/shared/ui';
import { useInvoiceFiles } from '../../hooks/use-invoice';
import type { ProviderInvoiceDetail } from '../../lib/invoices';

export type InvoiceActionsProps = {
  providerId: string;
  invoice: ProviderInvoiceDetail | null;
};

/** Save the invoice as a PDF, or open it to print. In the page header. */
export function InvoiceActions({ providerId, invoice }: InvoiceActionsProps) {
  const { download, print } = useInvoiceFiles(providerId, invoice);
  const busy = download.isPending || print.isPending;

  return (
    <div className="sk:flex sk:shrink-0 sk:items-center sk:gap-2">
      <Button
        size="md"
        isDisabled={!invoice || (busy && !download.isPending)}
        isPending={download.isPending}
        onPress={() => download.mutate()}
      >
        <FilePdfIcon size={14} weight="bold" />
        PDF
      </Button>
      <Button
        size="md"
        isDisabled={!invoice || (busy && !print.isPending)}
        isPending={print.isPending}
        onPress={() => print.mutate()}
      >
        <PrinterIcon size={14} weight="bold" />
        Print
      </Button>
    </div>
  );
}
